module.exports = __webpack_public_path__ + "img/00039.028e3662.webp";